module.exports = __webpack_public_path__ + "static/media/hot-label.08b13fef.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/resell/hot-label.png
// module id = 2020
// module chunks = 6